var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { CloseAd } from './CloseAd';
import { runtime } from '../../../../classes/runtime/Runtime';
let DfpAd = class DfpAd extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (app.appInfo.isMobileAppWebView)
            return null;
        if (app.appInfo.isPremiumApp)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "schlaukopf_leaderboard" }),
            React.createElement(CloseAd, { app: app })));
    }
    componentDidMount() {
        this.initAds();
    }
    async initAds() {
        if (runtime.isServerRuntime)
            return;
        if (this.props.app.appInfo.isMobileAppWebView)
            return;
        // await runtime.solidBrowserRuntime.browserIncludes.loadJQuery();
        runtime.solidBrowserRuntime.browserIncludes.includeJSFileOnce('https://cdns.symplr.de/schlaukopf.de/schlaukopf.js');
    }
};
DfpAd = __decorate([
    observer
], DfpAd);
export { DfpAd };
